import { render, staticRenderFns } from "./duplicate-template.vue?vue&type=template&id=517ff3c4"
import script from "./duplicate-template.vue?vue&type=script&lang=js"
export * from "./duplicate-template.vue?vue&type=script&lang=js"
import style0 from "./duplicate-template.vue?vue&type=style&index=0&id=517ff3c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports